module.exports = __webpack_public_path__ + "static/icons/icon-mail-a5cfddbd9afbecf2c91bc8a5c5744d18.svg";